import DialogBox from "../../Popups/ReusablePopup/DialogBox";
import { useSelector, useDispatch } from "react-redux";
import {
  setBreakdownColumnSetData,
  toggleCreateColumnSet,
} from "../../../../Redux/Actions/ColumnSetAction";
import FormikTextField from "../../../../Common/FormFields/FormikInputField";
import { Form, Formik } from "formik";
import validationSchema from "../../../../Validation/ValidationSchemas";
import userService from "../../../../services/user.service";
import { getFromLocalStorage } from "../../../../utils/webStorage";
import { openSuccessPopup } from "../../../../Redux/Actions/PopupActions";
import { openFailDialog } from "../../../../Redux/Actions/PopupActions";
import {
  setSelectedColumnSet,
  setActiveBreakdownForColumnSetSelected,
} from "../../../../Redux/Actions/VideoLibraryDataTableActions";
import { setColumnSetStatusData } from "../../../../Redux/Actions/ColumnSetAction";
const CreateSet = ({ setColumns, columns }) => {
  const dispatch = useDispatch();
  const schoolId = getFromLocalStorage("schoolId");
  const { isColumnSet } = useSelector((state) => state.ColumnSetData);
  const closeDialogBox = () => {
    toggleCreateColumnSet(dispatch, false);
  };
  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    userService
      .addNewColumnSet(schoolId, values?.columnSet)
      .then((data) => {
        userService
          .addBreakdownsToNewColumnSet(schoolId, values?.columnSet)
          .then((response) => {
            userService.getAllBreakDownColumnData(schoolId).then((res) => {
              const { breakdownMap, columnNameList } = res?.data?.data;
              const currentColumnSet = columnNameList.filter(
                (el) => el.isDefaultColumn
              );
              //active breakdown
              const newSortedData = breakdownMap[
                currentColumnSet[0]?.columnName
              ]["activeBreakdowns"].sort(
                (a, b) =>
                  parseInt(a.positionNumber) - parseInt(b.positionNumber)
              );
              const filteredActiveData = newSortedData.map((el) => ({
                ...el,
                id: el?.id.toString(),
              }));
              //hidden breakdown
              const newSortedData1 = breakdownMap[
                currentColumnSet[0]?.columnName
              ]["hiddenBreakdowns"].sort(
                (a, b) =>
                  parseInt(a.positionNumber) - parseInt(b.positionNumber)
              );
              const filteredHiddenData = newSortedData1.map((el) => ({
                ...el,
                id: el?.id.toString(),
              }));
              //set states
              setSelectedColumnSet(dispatch, {
                id: currentColumnSet[0]?.id,
                columnName: currentColumnSet[0]?.columnName,
              });
              setColumnSetStatusData(dispatch, columnNameList);
              setBreakdownColumnSetData(dispatch, breakdownMap);
              setActiveBreakdownForColumnSetSelected(
                dispatch,
                filteredActiveData
              );
              setColumns((prevState) => ({
                ...prevState,
                0: {
                  ...prevState["0"],
                  items: columnNameList,
                  loading: false,
                },
                1: {
                  ...prevState["1"],
                  items: filteredHiddenData,
                  loading: false,
                },
                2: {
                  ...prevState["2"],
                  items: filteredActiveData,
                  loading: false,
                },
              }));
            });
          });
        toggleCreateColumnSet(dispatch, false);
        openSuccessPopup(dispatch, {
          successPopUp: {
            message: "Breakdown column set added successfully!",
            open: true,
          },
        });
      })
      .catch((err) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something went wrong!",
        });
      });
    setSubmitting(false);
  };
  return (
    <>
      <DialogBox
        open={isColumnSet}
        onClose={closeDialogBox}
        variant="xs"
        title={
          <div className="d-flex-space-between">
            <p className="bold">Create New Column Set</p>
            <button
              className="breakdownTableCloseIcon"
              onClick={closeDialogBox}
            >
              <span>&times;</span>
            </button>
          </div>
        }
      >
        <Formik
          initialValues={{
            columnSet: "",
          }}
          validationSchema={validationSchema.columnSetSchema}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <Form>
              <FormikTextField
                label="Column Set"
                formik={formik}
                fieldName="columnSet"
                placeholder="Enter column set name"
                labelFontSize="fs-18"
              />
              <div className="d-flex-align-right">
                <button
                  className={formik.isValid ? "saveBtn1" : "saveBtn1 activv"}
                  type="submit"
                  disabled={!formik.isValid}
                >
                  Create
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </DialogBox>
    </>
  );
};

export default CreateSet;
